<script lang="ts" setup>
import type { ApiFaqCategory } from '~~/server/api/faq/category/[slug]'

definePageMeta({
    layout: false,
})
const route = useRoute()
const { $t } = useNuxtApp()

const { data: page, redirect } = await useFetchWithRedirect<ApiFaqCategory>(
    `/api/faq/category/${route.params.id}`,
    { route }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const breadcrumbs = computed<BreadcrumbsLink[]>(() => {
    const data: BreadcrumbsLink[] = [
        {
            name: 'Často kladené otázky',
            slug: useNamedRoutes({ name: 'faq' }),
        },
    ]

    page.value?.data.breadcrumbs.map((link: BreadcrumbsLink): void => {
        const linkItem: BreadcrumbsLink = {
            name: link.name,
            slug: useNamedRoutes({
                name: 'faq-category',
                params: { id: link.slug },
            }),
        }

        data.push(linkItem)
    })

    return data
})

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>
<template>
  <div v-if="page">
    <NuxtLayout name="faq">
      <template #page-header>
        <PagesFaqPageHeader
          :title="$t('S čím potrebujete pomôcť?')"
          heading-type="h1"
        />
      </template>
      <article>
        <h2 class="beta mb-8">
          {{ page.data.title }}
        </h2>
        <Tracker :data="{ position: page.data.title }">
          <FaqList
            :faq="page.data.faq"
            :children="page.data.children"
            :category-slug="page.data.slug"
          />
        </Tracker>
      </article>
      <template #aside>
        <PagesFaqCategoryMenu :data="page.data.above" />
      </template>
      <template #breadcrumbs>
        <Breadcrumbs
          :links="breadcrumbs"
          :current="page.data.title"
          class="mt-0"
        />
      </template>
    </NuxtLayout>
  </div>
</template>
